import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './TrialStart.scss';
import { GamePicker } from '../../../Components/GamePicker';
import Header from '../../../Components/Header';

const TrialStart = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className='trial_home start page_container'>
      <Header logo={true} name='Play60s' showLang={true}></Header>
      <div className='start_inner page_content'>

        <div className='page_subtitle'>{t('trial.title')}</div>

        <GamePicker />

        <div className='trial_button login_widget' onClick={() => navigate('/Login')}>
          <div className='message_icon member_game'></div>
          <div className='message_details'>
            {t('trial.toLoginText')}
          </div>
        </div>

        <div className='trial_button cashout_widget' onClick={() => navigate('/')}>
          <div className='message_icon home'></div>
          <div className='message_details'>
            {t('app.exitGame')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrialStart;
